import React, { Component } from 'react';
import { HashLink } from 'react-router-hash-link';

class About extends Component {
    constructor(props){
        super(props);
        this.state = {
            about: [
                {
                    id: 1,
                    icon: 'bi bi-badge2',
                    title: 'Recognized Excellence',
                    text: 'A Must-Have Resource for Professionals: Dive into Adaptive Control with Neural Networks!'
                },
                {
                    id: 2,
                    icon: 'bi bi-support',
                    title: 'Read Anytime, Anywhere',
                    text: 'Access Your Adaptive Control Guide on Any Device!'
                },
                {
                    id: 3,
                    icon: 'bi bi-rocket2',
                    title: 'Your Learning Journey Starts Here!',
                    text: 'Reach Your Goals with Adaptive Control!'
                }
            ],

            amazonLinks: [
                { country: "US", url: "https://www.amazon.com/dp/8409774860", flag: "us.png", currency: "USD" },
                { country: "UK", url: "https://www.amazon.co.uk/dp/8409774860", flag: "gb.png", currency: "GBP" },
                { country: "DE", url: "https://www.amazon.de/dp/8409774860", flag: "de.png", currency: "EUR" },
                { country: "FR", url: "https://www.amazon.fr/dp/8409774860", flag: "fr.png", currency: "EUR" },
                { country: "ES", url: "https://www.amazon.es/dp/8409774860", flag: "es.png", currency: "EUR" },
                { country: "IT", url: "https://www.amazon.it/dp/8409774860", flag: "it.png", currency: "EUR" },
                { country: "NL", url: "https://www.amazon.nl/dp/8409774860", flag: "nl.png", currency: "EUR" },
                { country: "PL", url: "https://www.amazon.pl/dp/8409774860", flag: "pl.png", currency: "PLN" },
                { country: "SE", url: "https://www.amazon.se/dp/8409774860", flag: "se.png", currency: "SEK" },
                { country: "BE", url: "https://www.amazon.com.be/dp/8409774860", flag: "be.png", currency: "EUR" },
                { country: "IE", url: "https://www.amazon.ie/dp/8409774860", flag: "ie.png", currency: "EUR" },
            ],

            showDropdown: false
        };

        this.dropdownRef = React.createRef();
    }

    componentDidMount() {
        document.addEventListener('click', this.handleDocumentClick);
        document.addEventListener('keydown', this.handleKeyDown);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleDocumentClick);
        document.removeEventListener('keydown', this.handleKeyDown);
    }

    handleDocumentClick = (e) => {
        if (!this.dropdownRef.current) return;
        if (this.state.showDropdown && !this.dropdownRef.current.contains(e.target)) {
            this.setState({ showDropdown: false });
        }
    };

    handleKeyDown = (e) => {
        if (e.key === 'Escape' && this.state.showDropdown) {
            this.setState({ showDropdown: false });
        }
    };

    toggleDropdown = (e) => {
        if (e && e.stopPropagation) e.stopPropagation();
        this.setState(prev => ({ showDropdown: !prev.showDropdown }));
    };

    handleAmazonClick = async (link, e) => {
      try {
        // URL dinámica para desarrollo y producción
        const backendUrl = window.location.hostname === 'neuralnetadaptivecontrol.com' 
          ? 'https://controlbook.onrender.com'
          : 'http://localhost:3000';
    
        await fetch(`${backendUrl}/clicks`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            sessionId: "session-" + Math.random().toString(36).substr(2, 9),
            elementId: "preordernow-" + link.country.toLowerCase(),
            pageUrl: window.location.href,
            elementType: "link",
            userId: "user-react",
            coordinates: { x: 100, y: 200 },
            metadata: {
              country: link.country,
              currency: link.currency,
              store: "amazon",
              product: "neural-networks-book"
            }
          }),
        });
      } catch (err) {
        console.error('Error recording click', err);
      }
    
      // Analytics
      if (typeof window.gtag === "function") {
        window.gtag("event", "conversion", {
          send_to: "AW-16832649503/ItwECMuR6ZIbEJ-yt9o-",
          value: 1.0,
          currency: link.currency,
        });
      }
      
      this.setState({ showDropdown: false });
    };

    render() {
        return (
            <section className="about-section section-padding bg-grey" id="about">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-6">
                            <div className="about-img">
                                <img src="assets/images/banner/book.png" alt="" className="img-fluid"/>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                            <div className="section-heading">
                                <span className="subheading">5% discount on early purchase</span>
                                <h3 className="heading-title">Get 5% Off on Your Early Purchase – Master Adaptive Control with Neural Networks Today!</h3>
                                <p>Early Purchase for the Ultimate Guide to Adaptive Control!</p>
                            </div>

                            {this.state.about.map((data,i) => (
                                <div className="about-text-block" key={i}>
                                    <i className={data.icon}></i>
                                    <h4>{data.title}</h4>
                                    <p>{data.text}</p>
                                </div>
                            ))}

                            {/* Dropdown con tiendas Amazon */}
                            <div className="dropdown mt-4" ref={this.dropdownRef}>
                                <button
                                    className="btn btn-main-2 dropdown-toggle"
                                    type="button"
                                    aria-haspopup="true"
                                    aria-expanded={this.state.showDropdown}
                                    onClick={this.toggleDropdown}
                                >
                                    <i className="fa fa-check me-2"></i>Preorder Now!
                                </button>

                                <div
                                    className={`dropdown-menu ${this.state.showDropdown ? 'show' : ''}`}
                                    style={{ maxHeight: 300, overflowY: 'auto' }}
                                >
                                    {this.state.amazonLinks.map((link) => (
                                        <a
                                            key={link.country}
                                            href={link.url}
                                            className="dropdown-item d-flex align-items-center"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            onClick={(e) => this.handleAmazonClick(link, e)}
                                        >
                                            <img
                                                src={`https://flagcdn.com/w20/${link.flag}`}
                                                alt={link.country}
                                                style={{ width: 20, marginRight: 8 }}
                                            />
                                            <span>Amazon {link.country}</span>
                                        </a>
                                    ))}
                                </div>
                            </div>
                                <p>
                                  Interested in a free chapter?{" "}
                                  <a
                                    href="/preview_merged.pdf"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={(event) => {
                                      // URL dinámica para desarrollo y producción
                                      const backendUrl = window.location.hostname === 'neuralnetadaptivecontrol.com' 
                                        ? 'https://controlbook.onrender.com'
                                        : 'http://localhost:3000';
                                
                                      // Trackear el click
                                      fetch(`${backendUrl}/clicks`, {
                                        method: 'POST',
                                        headers: { 'Content-Type': 'application/json' },
                                        body: JSON.stringify({
                                          sessionId: "session-" + Math.random().toString(36).substr(2, 9),
                                          elementId: "download-free-chapter2",
                                          pageUrl: window.location.href,
                                          elementType: "link", 
                                          userId: "user-react",
                                          coordinates: { x: event.clientX, y: event.clientY },
                                          metadata: {
                                            document: "preview_merged.pdf",
                                            type: "free-chapter",
                                            action: "download"
                                          }
                                        }),
                                      }).catch(err => console.error('Error tracking click:', err));
                                
                                    }}
                                  >
                                    Get it now
                                  </a>
                                </p>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default About;
